import styled from 'styled-components/macro'


export const Container = styled.div`
display: flex;
justify-content: center;
align-items: center;
padding: 3rem 0;

`

export const Row = styled.div`
    width: 100%;
    max-width: 1300px;
    padding: 0 2rem;
    color: #fff;
`


export const Title = styled.div`
 font-size: 30px;
   
`

export const Subtitle = styled.div``